/* istanbul ignore file */
import { kf1GetEnvironmentVariables } from 'kfone-frontend-core';
import { RBAC_PERSONA, RBAC_ROLE } from 'models/enum';
import { IRBACPersonaCombination } from 'shared/models/IRBAC.interface';

export const MODULE_NAME = 'kfone-kfnr-hm';

const moduleName = 'kfone-kfnr-hm';
let env: any = {};

(() => {
  try {
    env = kf1GetEnvironmentVariables(moduleName);
  } catch (err) {
    env = process.env;
  }
})();

export const eeEnvVariables = {
  APP_VERSION: env.VITE_APP_APP_VERSION,
  API_URL: env.VITE_APP_API_URL,
  SM_API_URL: env.VITE_APP_SM_API_URL,
  SP_API_URL: env.VITE_APP_SP_API_URL,
  HM_API_URL: env.VITE_APP_HM_API_URL,
  HM_OPEN_API_URL: env.VITE_APP_HM_OPEN_API_URL,
  SIGNALR_ENDPOINT: env.VITE_APP_SIGNALR_ENDPOINT,
  NO_AUTH_FLOW: env.VITE_APP_NO_AUTH_FLOW,

  TENANT_ID: env.VITE_APP_TENANT_ID,
  AUTH_CLIENT_ID: env.VITE_APP_AUTH_CLIENT_ID,
  RESOURCE_URI: env.VITE_APP_RESOURCE_URI,

  ENVIRONMENT: env.VITE_APP_ENVIRONMENT,
  MANIFEST_ID: env.VITE_APP_MANIFEST_ID,
  MANIFEST_VERSION: env.VITE_APP_MANIFEST_VERSION,

  TECHNICALASSESSMENT_VIDEO_ENDPOINT: env.VITE_APP_TECHNICALASSESSMENT_VIDEO_ENDPOINT,
  CONTACT_SUPPORT_EMAIL: env.VITE_APP_CONTACT_SUPPORT_EMAIL,
  CONTACT_SUPPORT_EMAIL_KFA: env.VITE_APP_CONTACT_SUPPORT_EMAIL_KFA,
  CONTACT_SUPPORT_PHONE: env.VITE_APP_CONTACT_SUPPORT_PHONE,
  CONTACT_SUPPORT_PHONE_KFA: env.VITE_APP_CONTACT_SUPPORT_PHONE_KFA,
  REALM_NAME: env.VITE_REALM_NAME,
  AUTH_URL: env.VITE_AUTH_URL,
  CLIENT_ID: env.VITE_CLIENT_ID,
  DOMAIN_URL: env.VITE_APP_DOMAIN_URL,
};

export const errorMessagesMap = new Map([
  ['SkillsResponse', 'updateSkillsFailed'],
  ['CareerExperienceResponse', 'updateCareerExperienceFailed'],
  ['CertificationsResponse', 'updateDegreesFailed'],
  ['OpenToNewRoleResponse', 'updateOpenToWorkFailed'],
  ['OpentoWorkRemoteResponse', 'updateOpenToRemoteFailed'],
  ['LocationsInterestedResponse', 'updateLocationsInterestedFailed'],
  ['InterestedRolesResponse', 'updateInterestedRolesFailed'],
  ['CompetenciesResponse', 'updateCompetenciesFailed'],
]);

export const longStringLength = 20;
export const mediumStringLength = 15;
export const maxLength = {
  workExperienceDesc: 4000,
  tuayInputFields: 150,
};

export const SM_APP_NAME = 'ic2';
export const SM_SYSTEM_AREA = 'Employee';

export const RBAC_PERSONA_COMBINATION: IRBACPersonaCombination[] = [
  {
    roleSet: [RBAC_ROLE.HIRING_MANAGER, RBAC_ROLE.TEAM_MANAGER, RBAC_ROLE.EMPLOYEE],
    personaMap: RBAC_PERSONA.UNIFIED,
  },
  {
    roleSet: [RBAC_ROLE.HIRING_MANAGER],
    personaMap: RBAC_PERSONA.HIRING_MANAGER,
  },
  {
    roleSet: [RBAC_ROLE.TEAM_MANAGER, RBAC_ROLE.EMPLOYEE],
    personaMap: RBAC_PERSONA.TEAM_MANAGER,
  },
  {
    roleSet: [RBAC_ROLE.EMPLOYEE],
    personaMap: RBAC_PERSONA.EMPLOYEE,
  },
  {
    roleSet: [RBAC_ROLE.KF_ASSESS_USER],
    personaMap: RBAC_PERSONA.KF_ASSESS_USER,
  },
  {
    roleSet: [RBAC_ROLE.KF_ASSESS_DEMO_USER],
    personaMap: RBAC_PERSONA.KF_ASSESS_DEMO_USER,
  },
  {
    roleSet: [
      RBAC_ROLE.EMPLOYEE,
      RBAC_ROLE.TEAM_MANAGER,
      RBAC_ROLE.KF_ASSESS_USER,
      RBAC_ROLE.KF_ASSESS_DEMO_USER,
    ],
    personaMap: RBAC_PERSONA.TEAM_MANAGER,
  },
];

export const QueryStringSet = {
  paramName: { access: 'access' },
  paramValue: { fromHome: 'fromHome' },
};

export const storagePersistedKey = {
  MSALIDToken: 'MSAL_ID_TOKEN',
  MSALPayload: 'MSAL_PAYLOAD',
  goToAssessments: 'goToAssessments',
};

export const REQUISITION_STATUS = {
  ADDED: 'Added',
  REJECT: 'Reject',
  SCREEN: 'Screen',
  INVITE_TO_APPLY: 'Invite to Apply',
  IN_PROGRESS: 'In progress',
  OPT_OUT_REJECT: 'Opt Out (Reject)',
  REJECT_CANDIDATE_WITH_FEEDBACK: 'Reject candidate (with feedback)',
};

export const ADAPTIVE_CARD_LABEL = {
  SCREENING_FEEDBACK: 'Screening Feedback',
};
